// extracted by css-extract-rspack-plugin
export default {"overlay":"V7OP8","message":"YYVMU"};